var _use, _use2, _g, _use3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeschwungen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 760 320",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    space: "preserve",
    serif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Pfosten",
    xlinkHref: "#_Image1",
    x: 563.957,
    y: 25.812,
    width: "32.954px",
    height: "294.254px",
    transform: "matrix(0.998595,0,0,0.99747,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pfosten",
    transform: "matrix(-1.16453,0,0,0.956172,1276.32,18.9457)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 588.961,
    y: 12.696,
    width: 18.851,
    height: 301.844,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image2",
    x: 0,
    y: 24.673,
    width: "760px",
    height: "266.314px",
    transform: "matrix(1,0,0,0.997429,0,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.422,32.263L8.422,276.135L582.551,275.919L582.551,31.027L590.973,31.027L590.973,57.994L760,275.745L760,284.244L8.422,284.502L8.422,284.505L0,284.505L0,32.263L8.422,32.263ZM591.364,74.688L590.973,276.138L743.615,275.783L591.364,74.688Z",
    style: {
      fill: "rgb(74,76,79)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "1101C",
    transform: "matrix(1,0,0,1,0,33)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.06697,96.002,-49.8364)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.08022,196.002,-52.0792)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.958,
    y: 51.268,
    width: 4.367,
    height: 226.733,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.1063,296.002,-59.3644)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.958,
    y: 51.268,
    width: 4.367,
    height: 226.733,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.13138,396.002,-69.8128)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.958,
    y: 52.002,
    width: 4.367,
    height: 228.301,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.19756,621.003,-85.8962)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.959,
    y: 49.803,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.20133,646.003,-86.0837)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.959,
    y: 49.803,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.18493,671.003,-81.4865)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.959,
    y: 49.803,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.16397,746.004,-76.4937)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 385.959,
    y: 49.803,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.14755,796.004,-71.8895)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.959,
    y: 49.803,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.10437,246.002,-55.0007)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.958,
    y: 49.803,
    width: 4.367,
    height: 226.167,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.12183,846.004,-66.8489)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 435.959,
    y: 49.803,
    width: 4.367,
    height: 232.433,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.11242,896.004,-63.6124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 460.959,
    y: 51.268,
    width: 4.367,
    height: 229.039,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.08598,946.004,-56.7316)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.959,
    y: 49.803,
    width: 4.367,
    height: 232.433,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.08977,148.002,-50.9719)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.958,
    y: 49.803,
    width: 4.367,
    height: 226.167,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.878683,0,0,1.13387,322.912,-64.7124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.958,
    y: 51.268,
    width: 4.367,
    height: 224.705,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.16953,446.002,-72.9845)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.958,
    y: 49.803,
    width: 4.367,
    height: 226.167,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.18627,496.002,-77.6043)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.958,
    y: 49.803,
    width: 4.367,
    height: 226.167,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.20338,521.002,-82.4058)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.958,
    y: 49.803,
    width: 4.367,
    height: 226.167,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.08299,1002,-54.0801)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 513.959,
    y: 49.936,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.06867,1052,-50.0635)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.959,
    y: 49.936,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.06866,1102,-50.0631)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 563.959,
    y: 49.936,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.06867,1127.2,-50.0635)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 563.959,
    y: 49.936,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "querbalken unten",
    transform: "matrix(1,-0,-0,1,0,-33)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image3",
    x: 8.279,
    y: 249.563,
    width: "574.432px",
    height: "8.729px",
    transform: "matrix(0.999011,0,0,0.969934,0,0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "querbalken unten",
    transform: "matrix(6.12323e-17,1,-1.99558,1.22194e-16,582.551,209.211)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 8.427,
    height: 287.7,
    style: {
      fill: "rgb(74,76,79)"
    }
  }))), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    id: "unteres Gestell",
    xlinkHref: "#_Image4",
    x: 0,
    y: 293.9,
    width: "760px",
    height: "18.067px",
    transform: "matrix(1,0,0,0.950886,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "unteres Gestell",
    transform: "matrix(0.988752,0,0,1.06875,-35.5535,244.288)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.958,
    y: 36.904,
    width: 768.624,
    height: 10.587,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M572.447,57.096L584.511,56.954L584.692,66.551L513.045,65.248L498.188,63.3L469.456,59.318L442.453,56.161L411.944,51.537L383.269,48.274L352.987,45.202L324.473,44.016L295.486,43.991L266.832,44.498L238.153,46.015L209.36,48.106L180.787,50.814L151.879,54.201L123.108,57.826L119.985,58.445L95.752,63.052L85.044,65.219L80.677,65.292L80.677,65.339L77.935,65.339L6.032,66.551L5.99,65.339L5.694,65.339L5.694,56.496L64.826,56.496L70.762,56.325L100.311,51.615L128.43,46.894L157.208,42.597L185.255,39.114L214.766,36.3L243.887,33.822L273.05,32.644L302.077,32.657L330.747,33.529L359.338,36.3L388.344,39.114L416.845,42.317L446.048,46.531L488.045,53.118L503.458,56.007L513.045,56.649L513.045,56.496L572.447,56.496L572.447,57.096Z",
    style: {
      fill: "rgb(74,76,79)"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "33px",
    height: "295px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAEnCAYAAAAnyirGAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACoElEQVR4nO3V0XLSUBRG4T9AodWq7/+c2goUEi/YixxSarHphRdrzWQAgXO+7KTY5XXdO68/2vDG86yubNa9cczZfHpcQLrJ4yLJsh55PhfS14Z9kmMdffPvF5Ng07s6Vs2xuAL+W+0Zs/EhyUvzeAauMp4lgE0dD0nWDWhx24lf1Deb7pJs62ihA5PoahMQj0m+JvmS5L4QXJpbGzJOYJvkudZo33uFWNZmDwX4keRbQdYZ7xU+/x6Ae2BfgLt675jTZM6X+Nok1rXx94I85jSd9tLdEpdiV2sm41S2dVIHECzc3pj3OU3kMadpbPKxe2LIeA+0E2kvbTf9nVhk/ItYZ7xJl/lYXU4ntM/rm/x8OabXuJ1I++c5J06s/f3pph9o1dNfzbmAdp/p5l375lt91v8Z7/ZZZzorESSCRJAIEkEiSASJIBEkgkSQCBJBIkgEiSARJIJEkAgSQSJIBIkgESSCRJAIEkEiSASJIBEkgkSQCBJBIkgEiSARJIJEkAgSQSJIBIkgESSCRJAIEkEiSASJIBEkgkSQCBJBIkgEiSARJIJEkAgSQSJIBIkgESSCRJAIEkEiSASJIBEkgkSQCBJBIkgEiSARJIJEkAgSQSJIBIkgESSCRJAIEkEiSASJIBEkgkSQCBJBIkgEiSARJIJEkAgSQSJIBIkgESSCRJAIEkEiSASJIBEkgkSQCBJBIkgEiSAR9F8ihuZ5P3k9p+HKWufXiysf7Jvj+AmQodY5ZjyxizUXzQdbxCHJS5J9PZ9Tu85hgkmSrCaIY/OlbZLngt4nWebf7iEmyTq/k+xqfSY9JBlWjehY0n194WdtekiymYHYJXlK8qvWZSrnabST6Eu5rS90tchzknUBujpuicky1ac6thmnMSTJH/Hml1gt/DGjAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "760px",
    height: "267px",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image3",
    width: "575px",
    height: "9px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAj8AAAAJCAYAAADdEE2uAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAdklEQVR4nO3asQ3CMBBA0Q/xCjSMxP5bZAZHFIERokjJe5IbV1d+2feoPtWregYAcF1btY728HlXy7nzAAAcalaN9uj5HwCAK1t8dQEAtyJ+AIBbET8AwK2IHwDgVkb75vM8exAAgIPNao5q/V14BQIArmyr1i8zYQppg3gGZAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image4",
    width: "760px",
    height: "19px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAvgAAAATCAYAAADlPnmLAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABSklEQVR4nO3dzWrUABSA0S/TtGoRBDf2/d/OhaB2dNrOT1zEOG4Ed5pwDiRZhECWH5dLMlRjtQsAAFiraTnG6r66qYafN4c/PQUAAPw3pt+ul+pcHcfqfXXbHPkl8AEAYA2WwL9Ux+q5OozVh+pNc+SLewAAWI+pOlVP1WP1eaweqrfVq+ziAwDAmizT+2/NA/vzsqJzn7gHAIA1mpqH9cdqv2tezxH3AACwTkNz07+u7oQ9AABsw021E/gAALANu18nAABgEwaBDwAAGyLwAQBgGy7VJPABAGAbztVlVx26/uYWAABYn0Pz32xfxupT9VLdNX9Dc/iHLwYAAPy9S3Wq9tWX6jBWH6uv1ZidfAAAWJOpOfCfqsdqvwT+bXPcm+ADAMA6LGv2l+pYPVffh+pd17gHAADWZeq6qnMamqf34h4AANZrifx+AMnPO87xJZEhAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeschwungen);
export default __webpack_public_path__ + "static/media/geschwungen.def88bd687c50f87ff3dc9bc4da2c8e3.svg";
export { ForwardRef as ReactComponent };